import { render, staticRenderFns } from "./EditProfileScreen.vue?vue&type=template&id=a230ab2a&scoped=true&"
import script from "./EditProfileScreen.vue?vue&type=script&lang=js&"
export * from "./EditProfileScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a230ab2a",
  null
  
)

export default component.exports